module.exports = __webpack_public_path__ + "static/media/ic-placeholder.5713baf3.svg";